import React, { useCallback } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives';

import { EmojiTitleButtonLoader } from '@confluence/emoji-title/entry-points/EmojiTitleButton';

import type { EmojiButtonProps } from './titleareaContentComponentsTypes';

export const EmojiButton = ({
	contentId,
	userOffline,
	isTitleDisabled,
	isUnpublishedDraft,
	setSelectedEmoji,
	onEmojiPickerLoaded,
	onUpdateStartEmoji,
	onUpdateEndEmoji,
	floatingToolbarButtonStyle,
	contentType,
	autoPageEmojiCohort,
	emojiTitleDiscovered,
}: EmojiButtonProps) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleOnMouseEnter = useCallback(() => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'hovered',
				source: 'EmojiTitleSection',
				actionSubject: 'pageTitle',
				actionSubjectId: 'emojiButton',
				attributes: {
					element: 'div',
				},
			},
		}).fire();
	}, [createAnalyticsEvent]);

	const handleOnMouseLeave = useCallback(() => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'not:hovered',
				source: 'EmojiTitleSection',
				actionSubject: 'pageTitle',
				actionSubjectId: 'emojiButton',
				attributes: {
					element: 'div',
				},
			},
		}).fire();
	}, [createAnalyticsEvent]);

	return (
		<Box
			testId="emoji-title-hover-button-wrapper"
			onMouseEnter={handleOnMouseEnter}
			onMouseLeave={handleOnMouseLeave}
		>
			<EmojiTitleButtonLoader
				isUnpublishedDraft={isUnpublishedDraft}
				setSelectedEmoji={setSelectedEmoji}
				onEmojiPickerLoaded={onEmojiPickerLoaded}
				disableEmoji={userOffline}
				contentId={contentId}
				isTitleDisabled={isTitleDisabled}
				onUpdateStartEmoji={onUpdateStartEmoji}
				onUpdateEndEmoji={onUpdateEndEmoji}
				floatingToolbarButtonStyle={floatingToolbarButtonStyle}
				contentType={contentType}
				autoPageEmojiCohort={autoPageEmojiCohort}
				emojiTitleDiscovered={emojiTitleDiscovered}
			/>
		</Box>
	);
};
